import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import TiaowenPageList from "./TiaowenPageList";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import SERVER_ADDRESS from "../../../../config";
import ReactLoading from "react-loading";
// import store from "../../../../reduxstore";
// import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },

  divider: {
    marginBottom: theme.spacing(1)
  },

  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "100%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  loader: {
    margin: "auto"
  }
}));

function useTiaowens(initValue, fetchUrl) {
  const [tiaowens, setTiaowens] = useState(initValue);
  useEffect(() => {
    async function getGoujianTiaowens() {
      let tws = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include"
      }).then(res => {
        return res.json();
      });
      setTiaowens(tws);
      console.log(tws.length);
    }
    getGoujianTiaowens();
  }, []);

  //freshData
  const freshData = (data, method = "update", deleteId) => {
    if (method === "update") {
      setTiaowens((prevTiaowens, props) => {
        const newTiaowens = [];
        prevTiaowens.forEach(tiaowen => {
          newTiaowens.push(tiaowen.id === data.id ? data : tiaowen);
        });
        return newTiaowens;
      });
    }
    if (method === "delete") {
      setTiaowens((prevTiaowens, props) => {
        const newTiaowens = [];
        prevTiaowens.forEach(tiaowen => {
          if (tiaowen.id !== deleteId) {
            newTiaowens.push(tiaowen);
          }
        });
        return newTiaowens;
      });
    }
    if (method === "add") {
      setTiaowens([...tiaowens, data]);
    }
  };
  return { tiaowens, freshData };
}

function GoujianTiaowens(props) {
  const classes = useStyles();
  let queryUrl = `${SERVER_ADDRESS}/api/tiaowens.json/`;
  // const { account } = store.getState();
  // const [mine, setMine] = useState(false);
  // const queryParam = mine ? `?user__nickname={account.nickname}` : "";

  //条文
  const { tiaowens, freshData } = useTiaowens([], queryUrl);
  //过滤state

  return (
    <Grid container className={classes.paper} component={Paper} spacing={1}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          gutterBottom
          color="secondary"
          className={classes.typography}
        >
          全部条文
        </Typography>
        {/* <Typography
          variant="subtitle1"
          color="textPrimary"
          className={classes.typography}
        >
          {`共${tiaowens.length}条`}
        </Typography> */}
        <Divider variant="fullWidth" className={classes.divider} />
      </Grid>

      <Grid item xs={12}>
        {tiaowens.length === 0 ? (
          <ReactLoading
            type="bars"
            color="#117BEA"
            className={classes.loader}
          />
        ) : (
          <TiaowenPageList tiaowens={tiaowens} freshData={freshData} />
        )}
      </Grid>
    </Grid>
  );
}

export default GoujianTiaowens;
